import { useTranslation } from 'react-i18next';

import { FileOff } from 'tabler-icons-react';

import { UploadPDFButton } from 'components/shared';

import NoItemsNotification from '../../NoItemsNotification';

import styles from './NoDocumentsNotification.module.css';

type NoDocumentsNotificationProps = {
   supplierMode?: boolean;
   onUploadDocument: (document: FileList) => void;
   uploadBtnId?: string;
};

const NoDocumentsNotification = ({
   supplierMode,
   onUploadDocument,
   uploadBtnId,
}: NoDocumentsNotificationProps) => {
   const { t } = useTranslation();

   return (
      <NoItemsNotification
         icon={<FileOff color="var(--gray-section-subtitle)" size={48} />}
         description={
            supplierMode
               ? t('noDocumentsNotification.supplier')
               : t('noDocumentsNotification.client')
         }
         button={
            <UploadPDFButton
               id={uploadBtnId}
               onUploadDocument={onUploadDocument}
               variant="outlined-primary"
            />
         }
         className={styles.container}
      />
   );
};

export default NoDocumentsNotification;
